import { useState, type ReactNode } from 'react';
import { Alert, Box, Button, Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import { brainTokens } from '../../design/brainTheme';
import { Icon } from '../../mui';

const c = brainTokens.color;
export function VisualFrame({ title, description, source, error, children, controls }: {
  title: string;
  description?: string;
  source: string;
  error?: string;
  children?: (expanded: boolean) => ReactNode;
  controls?: ReactNode;
}) {
  const [showSource, setShowSource] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const body = (full: boolean) => <>
    {error && <Alert severity="warning" sx={{ m: 2, background: c.warnBg3, color: c.warnText }}>{error}</Alert>}
    {showSource || error ? <Box component="pre" sx={{ m: '0 !important', p: 2, maxHeight: full ? '70vh' : 360, overflow: 'auto', fontSize: 12, whiteSpace: 'pre-wrap' }}><code>{source}</code></Box> : children?.(full)}
  </>;
  return <Box data-document-visual sx={{ my: 2.5, border: `1px solid ${c.border}`, borderRadius: `${brainTokens.radius.panel}px`, overflow: 'hidden', background: c.white }}>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 2, py: 1.25, background: c.panelBg3, borderBottom: `1px solid ${c.borderLight}`, flexWrap: 'wrap' }}>
      <Box sx={{ color: c.tealInk, display: 'flex' }}><Icon name="atlas" size={18}/></Box>
      <Box sx={{ flex: 1, minWidth: 120, fontSize: 13, fontWeight: 650, color: c.ink }}>{title}</Box>
      {!showSource && !error && controls}
      <Button size="small" sx={{ color: c.tealInk }} aria-pressed={showSource} onClick={() => setShowSource(v => !v)}>{showSource ? 'Visual' : 'Source'}</Button>
      <IconButton size="small" aria-label={`Expand ${title}`} onClick={() => setExpanded(true)}><Icon name="external-link" size={16}/></IconButton>
    </Box>
    {description && <Box sx={{ px: 2, pt: 1.5, fontSize: 12.5, color: c.muted }}>{description}</Box>}
    {!expanded && body(false)}
    <Dialog open={expanded} onClose={() => setExpanded(false)} maxWidth="xl" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, fontSize: 16 }}>{title}<Box sx={{ flex: 1 }}/>{!showSource && !error && controls}<Button size="small" sx={{ color: c.tealInk }} onClick={() => setShowSource(v => !v)}>{showSource ? 'Visual' : 'Source'}</Button><IconButton aria-label="Close expanded visual" onClick={() => setExpanded(false)}><Icon name="close" size={18}/></IconButton></DialogTitle>
      <DialogContent sx={{ p: 0, '&:first-of-type': { pt: 0 } }}>{expanded && body(true)}</DialogContent>
    </Dialog>
  </Box>;
}
